import React, { useState, useContext, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { ObjModal } from '../../../../contexts';


const Checkbox = ( { label, db, value, formId = 'gen' } ) => {
    const { setDraftValues } = useContext( ObjModal );
    const [ v, setV ] = useState( ( value ) ? value : false );

    const handleDraft = ( e ) => {
        setV( e.target.checked );
        setDraftValues( prevState => (
            {
                ...prevState,
                [db]: e.target.checked
            }
        ) );
    }

    useEffect( () => {
        if ( value ) {
            setV( value );
        }
    }, [ value ] );

    return (
        <Col className='tf-obj-data-element'>
            <Form.Group as={Row} className='tf-form-group align-items-center py-1' controlId={`${formId}-${db}`}>
                <Form.Label column xs='auto' className='col-md-auto p-0 tf-form-label'>{label}</Form.Label>
                <Col className='me-1'>
                    <Form.Check type='checkbox' className='tf-form-checkbox-field' aria-label={db} checked={v} onChange={handleDraft} />
                </Col>
            </Form.Group>
        </Col>
    )
}

export default Checkbox;